/**
 * Created by ostapenko.r on 7/24/2014.
 */
angular
    .module("flipto.components.incentives",
    [
        "flipto.core.lodash",
        "flipto.core.api.settingsIncentive"
    ]);